"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var tokens_1 = __importDefault(require("@paprika/tokens"));
var constants_1 = require("../../constants");
var ThemeProvider_1 = require("../theme/ThemeProvider");
function NavigationIcon(_a) {
    var icon = _a.icon;
    var Icon = icon;
    var isTrainingOrg = ThemeProvider_1.useTheme().isTrainingOrg;
    return (react_1.default.createElement(Icon, { "data-sri-anchor": "navigation-item.icon", color: isTrainingOrg ? tokens_1.default.color.blackLighten10 : tokens_1.default.color.white, size: constants_1.iconSize }));
}
NavigationIcon.propTypes = {
    icon: prop_types_1.default.func.isRequired,
};
exports.default = NavigationIcon;
//# sourceMappingURL=NavigationIcon.js.map